import { Button, DialogFooter, NativeSelect, StatusBadge } from "@nexxt/ui";
import { m } from "../paraglide/messages.js";
import { Refusal } from "./refusal";

// What is archived is out of the lists and of the pickers, never deleted: the same badge, the same filter and the
// same way back for every feature that archives.

/** The badge of something archived; nothing for what is not. */
export function ArchivedBadge({ archivedAt }: { archivedAt: string | null | undefined }) {
  return archivedAt ? <StatusBadge tone="neutral" label={m.archived_badge()} /> : null;
}

interface ArchiveFilterProps {
  archived: boolean | undefined;
  /** `true` for the archived ones, nothing for the others: what the URL keeps. */
  onChange: (archived: true | undefined) => void;
}

/** A list shows what is in use or what is archived, never both. */
export function ArchiveFilter({ archived, onChange }: ArchiveFilterProps) {
  return (
    <NativeSelect
      aria-label={m.filter_archive_label()}
      value={archived ? "archived" : "active"}
      onChange={(e) => onChange(e.target.value === "archived" || undefined)}
    >
      <option value="active">{m.filter_active()}</option>
      <option value="archived">{m.filter_archived()}</option>
    </NativeSelect>
  );
}

interface RestoreOnlyProps {
  /** What being archived means for this entity, and what restoring it gives back. */
  hint: string;
  pending: boolean;
  /** What the restore failed with: a refusal of the domain (422) is read here. */
  error: unknown;
  onRestore: () => void;
  onCancel: () => void;
}

/** The body of the dialog of something archived, which takes no change: it can only be brought back. */
export function RestoreOnly({ hint, pending, error, onRestore, onCancel }: RestoreOnlyProps) {
  return (
    <div className="grid gap-3">
      <p className="text-sm text-muted-foreground">{hint}</p>
      <Refusal error={error} />
      <DialogFooter>
        <Button variant="ghost" onClick={onCancel}>
          {m.cancel()}
        </Button>
        <Button variant="primary" disabled={pending} onClick={onRestore}>
          {m.action_unarchive()}
        </Button>
      </DialogFooter>
    </div>
  );
}
